import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {EducationService} from '../core/ecv-http-services/services/education.service';
import {StepComponentAbstract} from '../flow/step.component';
import {ValidatorService} from '../core/validator/validator.service';
import {EducationItemModel} from './education-item.model';
import DateUtils from '../shared/date-utils';
import {Observable} from 'rxjs/Observable';
import {AlertService} from '@widgets/alert/alert.service';
import {TranslateService} from '@ngx-translate/core';
import {AlertUtils} from '@widgets/../shared/AlertUtils';


@Component({
  templateUrl: './education.component.html'
})
export class EducationComponent extends StepComponentAbstract implements OnInit {

  @Input() data: any;
  educationItemModel: EducationItemModel[];
  userId: number;

  constructor(private educationService: EducationService,
              private validatorService: ValidatorService,
              private translateService: TranslateService,
              private alertService: AlertService) {
    super();
    this.educationItemModel = [];
  }

  ngOnInit(): void {
    this.createForm();
  }

  addEducation() {
    const newItem: EducationItemModel = new EducationItemModel();
    newItem.userId = this.userId;
    this.educationItemModel.push(newItem);
  }

  removeEducation(index: number) {
    this.educationItemModel[index].deleted = true;
  }

  private createForm() {
    this.stepForm = new FormGroup({});
  }

  onSave(): Observable<any> {
    if (this.isSaveInProgress) {
      return Observable.of(true);
    }
    this.validatorService.validate(this.stepForm);
    if (!this.validatorService.isValid(this.stepForm)) {
      return Observable.of(false);
    }

    if (!this.checkIfAtLeastOneEducationModelWasAdded(this.educationItemModel.length)) {
      return Observable.of(false);
    }

    const changes: Observable<any>[] = this.updateChanges();
    if (changes.length === 0 && !this.checkIfAtLeastOneEducationModelWasAdded(changes.length)) {
      return Observable.of(false);
    } else {
      this.isSaveInProgress = true;
      return Observable.forkJoin(changes)
        .map(() => {
          this.isSaveInProgress = false;
        }, () => {
          this.isSaveInProgress = false;
        });
    }
  }

  loadData(userId): void {
    this.userId = userId;

    this.educationService.getAllEducations(userId).subscribe(
      response => {
        this.educationItemModel = response;
      });
  }

  updateChanges(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (let education of this.educationItemModel) {
      education.dateFrom.dateFormat = DateUtils.parseDateFormat(education.dateFrom.date);
      education.dateTo.dateFormat = DateUtils.parseDateFormat(education.dateTo.date);
      if (education.id && education.deleted) {
        changes.push(this.educationService.deleteEducation(education));
      } else if (education.deleted) {
        continue;
      } else if (education.id) {
        changes.push(this.educationService.updateEducation(education));
      } else {
        changes.push(this.educationService.createEducation(education));
      }
    }
    return changes;
  }

  checkIfAtLeastOneEducationModelWasAdded(educationItems: number): boolean {
    if (educationItems > 0) {
      return true;
    }
    AlertUtils.showAlert(false, 'ALERT.NO_EDUCATION_ADDED', this.translateService, this.alertService);
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/education/education.component.ts